import { jwtDecode, JwtPayload } from 'jwt-decode';
import { useEffect } from 'react';

const getExpirationDelay = (accessToken: string): number => {
  try {
    const expiresAt = jwtDecode<JwtPayload>(accessToken).exp;
    return expiresAt ? expiresAt * 1000 - Date.now() : 0;
  } catch {
    return 0;
  }
};

const useAccessTokenExpiration = (accessToken: string | undefined, onExpire: () => void) => {
  useEffect(() => {
    if (!accessToken) {
      return;
    }

    const expirationDelay = getExpirationDelay(accessToken);

    if (expirationDelay <= 0) {
      onExpire();
      return;
    }

    const expirationTimer = window.setTimeout(onExpire, expirationDelay);
    return () => window.clearTimeout(expirationTimer);
  }, [accessToken, onExpire]);
};

export default useAccessTokenExpiration;
